<template>
  <div
    class="flex flex-center q-pa-md"
    padding
  >
    <q-form
      class="q-gutter-md"
      style="width: 65vw"
    >
      <fieldset>
        <legend class="text-left text-h5">
          Description
        </legend>
        <q-separator />
        <br />
        <div v-html="sessionDetails.description" />
      </fieldset>
    </q-form>
  </div>
</template>

<script>
import useSession from '@/hooks/session';

export default {
  async setup() {
    const {
      sessionId, sessionDetails, fetchSession,
    } = useSession();

    if (sessionId.value) {
      fetchSession(sessionId.value);
    }

    return {
      sessionDetails,
    };
  },
};
</script>

<style>
</style>
